import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'components/loaders/Loader';

import { Component, Label } from './Loading.styles';

const Loading = ({
  loadingLabel,
  full,
  fullHeight,
  fullAbsolute,
  className,
  small,
}) => {
  return (
    <Component
      className={className}
      full={full}
      fullHeight={fullHeight}
      fullAbsolute={fullAbsolute}
      small={small}
    >
      <Loader />
      <Label small={small}>{loadingLabel}</Label>
    </Component>
  );
};

Loading.propTypes = {
  loadingLabel: PropTypes.string.isRequired,
  full: PropTypes.bool,
  fullAbsolute: PropTypes.bool,
  small: PropTypes.bool,
  fullHeight: PropTypes.bool,
  className: PropTypes.string,
};

Loading.defaultProps = {
  full: false,
  fullHeight: false,
  fullAbsolute: false,
  small: false,
  className: '',
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js